import React from 'react'
import cx from 'classnames'

import { Item } from './common/Item/Item'

import styles from './List.module.scss'

type ListTagName = 'ul' | 'ol' | 'menu'

type ListProps = React.HTMLAttributes<HTMLUListElement | HTMLOListElement | HTMLElement> & {
  ariaLabel?: string
  direction?: string
  tagName?: ListTagName
}

type ListComponent = ((props: ListProps) => React.JSX.Element) & {
  Item: typeof Item
}

export const List: ListComponent = Object.assign(({
  ariaLabel,
  children,
  className,
  direction,
  tagName,
  ...restProps
}: ListProps) => {
  const Component = tagName ?? 'ul'

  return (
    <Component
      aria-label={ariaLabel}
      className={cx(styles.list, styles.direction, {
        [styles[`direction-${direction}`]]: Boolean(direction),
      }, className)}
      {...restProps}
    >
      {children}
    </Component>
  )
}, {
  Item,
})
